import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeControl({ compact = false }) {
  const { mode, theme, setMode } = useTheme();
  if (compact) return <button type="button" className="eh-theme-quick" data-testid="theme-toggle" aria-label={`Aktifkan mode ${theme === "dark" ? "terang" : "gelap"}`} title={`Mode ${theme === "dark" ? "terang" : "gelap"}`} onClick={() => setMode(theme === "dark" ? "light" : "dark")}>
    {theme === "dark" ? <Sun size={18}/> : <Moon size={18}/>}
  </button>;
  return <div className="eh-theme-control" role="group" aria-label="Tema tampilan">
    {[["light", "Terang", Sun], ["dark", "Gelap", Moon], ["system", "Sistem", Monitor]].map(([value, label, Icon]) =>
      <button type="button" key={value} onClick={() => setMode(value)} aria-pressed={mode === value} data-testid={`theme-${value}`}><Icon size={15}/><span>{label}</span></button>)}
  </div>;
}
